import type { AuthStatus } from '@/domain/types';
import type { AuthorizeResponse } from '@/protocol/OcppAdapter';

export function buildAuthorizeRequest(idTag: string): Record<string, unknown> {
  return { idTag };
}

export function parseAuthorizeResponse(payload: Record<string, unknown>): AuthorizeResponse {
  const info = (payload['idTagInfo'] ?? {}) as Record<string, unknown>;
  return {
    idTagInfo: {
      status: info['status'] as AuthStatus,
      ...(typeof info['expiryDate'] === 'string' ? { expiryDate: info['expiryDate'] } : {}),
      ...(typeof info['parentIdTag'] === 'string' ? { parentIdTag: info['parentIdTag'] } : {}),
    },
  };
}
